import videoBanner from "../assets/videos/hero-video.mp4";
import logo from "../assets/images/logo-bg-removed.png";

function Hero() {
	return (
		<div className="hero-container">
			<video
				src={videoBanner}
				id="banner-video"
				autoPlay
				muted
				loop
				playsInline
				disablePictureInPicture
				className="hero-video"
			/>
			<div className="hero-text-overlay">
				<div className="hero-text-overlay-content">
					<div className="d-flex justify-content-center">
						<h1>
							<img src={logo} alt="Mane & Bare Logo" />
							MANE & BARE
						</h1>
					</div>
					<p>Hair &bull; Skin &bull; Wellness</p>
					<a href="#team">
						<button>Book Now</button>
					</a>
				</div>
			</div>
		</div>
	);
}

export default Hero;
